<template>
    <FirstPage :section="1" :audio="true">
        <p>
            LifeSkills Mobile is an app designed for and by trans folks like you. In this app, you’ll work your way through the levels of the House of
            LifeSkills. Along the way, your knowledge and skills will grow to help you achieve your life goals and to protect yourself too!
        </p>
        <p>
            Just FYI – anything you share in this app is confidential. Your responses won’t be shared with anyone outside of the research team, unless you share
            them yourself!
        </p>
        <v-dialog v-model="firstTime" persistent>
            <v-card class="client-dialog">
                <v-card-text>
                    <ResponsiveImage
                        :src="require('@/assets/poses/queenie_head.png')"
                        :max-height="150"
                        alt="Queenie"
                        layout="justify-center mb-3"
                        flex="xs4"
                    ></ResponsiveImage>
                    <p>Looks like it's your first time here! A couple of quick notes:</p>
                    <ul>
                        <li>
                            Many of the screens have audio associated with them - when they do, there is a speaker icon at the top of the screen. Tapping that
                            icon toggles the audio on/off - it's off by default, but give it a try, I'd love to talk to you!
                        </li>
                        <li>
                            On the top right of every screen there is a help icon. If you ever have any issues with the app or can't figure out an activity, tap
                            that icon to send a message to a study coordinator who will help you out!
                        </li>
                    </ul>
                    <br />
                    <p>That's all you need to know to get started, let's go!</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn round outline color="primary" @click="dismiss">Got it!</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </FirstPage>
</template>

<script>
import { sync } from 'vuex-pathify';

export default {
    computed: {
        firstTime: sync('firstTime')
    },
    methods: {
        dismiss() {
            this.firstTime = false;
        }
    }
};
</script>
